// extracted by mini-css-extract-plugin
module.exports = {"buffer":"MemoryBuffer_buffer__2XewS","bufferActive":"MemoryBuffer_bufferActive__3FPEN"};